import {useRef} from "react";
import {MultiSelect} from "@mantine/core";
import type {LabelGroup} from "../types";

type ShowFilterProps = {
    group: LabelGroup;
    selected: string[];
    onToggle: (labelId: string) => void;
};

export const ShowFilter = ({group, selected, onToggle}: ShowFilterProps) => {
    const prevRef = useRef<string[]>([]);
    prevRef.current = selected;

    const data = group.labels.map((l) => ({value: l.id, label: l.name}));

    const handleChange = (newValue: string[]) => {
        const prev = new Set(prevRef.current);
        const next = new Set(newValue);

        for (const v of next) {
            if (!prev.has(v)) {
                onToggle(v);
                return;
            }
        }
        for (const v of prev) {
            if (!next.has(v)) {
                onToggle(v);
                return;
            }
        }
    };

    return (
        <MultiSelect
            data={data}
            value={selected}
            onChange={handleChange}
            placeholder={group.name}
            size="sm"
            clearable
            style={{minWidth: "10rem", maxWidth: "16rem"}}
        />
    );
};
